import { useEffect } from "react"
import { useSetAtom } from "jotai"
import { useRouteScene } from "@/routing/route-state"
import { homeSectionAtom } from "@/store/ui-views-state"

export function useRouteUIStateSync() {
	const scene = useRouteScene()
	const setHomeSection = useSetAtom(homeSectionAtom)

	useEffect(() => {
		if (scene.homeSection) {
			setHomeSection(scene.homeSection)
		}
	}, [scene.homeSection, setHomeSection])
}
